import { parseHeaderFromCMS } from '@/lib/contentstack-sdk/utils/parseHelpers';
import { MlHeader } from './ml-header';

import mlHeaderVariants from './ml-header.variants';
import { IMlHeaderCMSProps } from './ml-header.types';
import {
  EDividerColors,
  EDividerDirectionalVariants,
  EDividerVariants,
} from '@/components/atoms/at-divider/at-divider.types';
import { AtDivider } from '@/components/atoms/at-divider/at-divider';

export const MlHeaderCS = (props: IMlHeaderCMSProps) => {
  if (!props) return null;

  const parsedProps = parseHeaderFromCMS(props);

  const { cmsSpacing } = mlHeaderVariants({
    topSpacing: props?.top_spacing?.spacing_value || 'md',
    bottomSpacing: props?.bottom_spacing?.spacing_value || 'md',
  });
  const topDivider = props?.top_spacing?.divider;
  const bottomDivider = props?.bottom_spacing?.divider;

  return (
    <div className="container">
      {topDivider && (
        <AtDivider
          decorative
          color={EDividerColors.GREY}
          direction={EDividerDirectionalVariants.HORIZONTAL}
          intent={EDividerVariants.THIN}
        />
      )}
      <div className={cmsSpacing()}>
        <MlHeader {...parsedProps} />
      </div>
      {bottomDivider && (
        <AtDivider
          decorative
          color={EDividerColors.GREY}
          direction={EDividerDirectionalVariants.HORIZONTAL}
          intent={EDividerVariants.THIN}
        />
      )}
    </div>
  );
};
